import { LoadableAfterPaint } from '@confluence/loadable';

export const PageIncludeSSRExtensionHandler = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-PageIncludeSSRExtensionHandler" */ '../src/PageIncludeSSRExtensionHandler.tsx'
			)
		).PageIncludeSSRExtensionHandler,
});
